export const getCsrfParam = () => {
  const param = document.querySelector<HTMLMetaElement>(
    "meta[name=csrf-param]",
  );
  return param?.content;
};

export const getCsrfToken = () => {
  const token = document.querySelector<HTMLMetaElement>(
    "meta[name=csrf-token]",
  );
  return token?.content ?? "";
};
